import React, { ReactElement } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { UIMenu } from '../../ui';
import { IMenuItem } from '../../ui/UIMenu/IMenuItem';
import { menuItems } from './menuItems';

// A menu item is active on its own page and on pages below it, so `/beogram`
// matches `/beogram/400x/articles` but `/articles/beogram-4002-riaa` doesn't.
const isActive = (pathname: string, link?: string): boolean => {
  if (!link?.startsWith('/')) {
    return false;
  }

  return pathname === link || pathname.startsWith(`${ link }/`);
};

export const Navigation = (): ReactElement => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Derived from the current URL on every render, so it's right on the server,
  // after back/forward, and after following links outside the menu.
  const activeMenuItems = React.useMemo((): IMenuItem[] => menuItems.map((item: IMenuItem) => {
    const children = item.menuItems?.map((child: IMenuItem) => ({ ...child, active: isActive(pathname, child.link) }));

    return {
      ...item,
      active: isActive(pathname, item.link) || (children?.some((child: IMenuItem) => child.active) ?? false),
      menuItems: children
    };
  }), [pathname]);

  return (
    <UIMenu
      menuItems={ activeMenuItems }
      onNavigate={ (destination: IMenuItem) => {
        if (destination.link?.startsWith('https://')) {
          window.location.href = destination.link;
        } else if (destination.link) {
          navigate(destination.link);
        }
      } } />
  );
};
